"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getTimeAndExpenseEntry = getTimeAndExpenseEntry;
exports.setTimeAndExpenseEntry = setTimeAndExpenseEntry;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _session = require("../session");

function getTimeAndExpenseEntry(_x) {
  return _getTimeAndExpenseEntry.apply(this, arguments);
}

function _getTimeAndExpenseEntry() {
  _getTimeAndExpenseEntry = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(options) {
    return _regenerator.default.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _promise.default.all([(0, _environment.getRoute)('CoreServices'), options.companyId ? options.companyId : (0, _session.getCompanyId)(), options.contactId ? options.contactId : (0, _session.getContactId)()]).then(function (_ref) {
              var _context, _context2;

              var _ref2 = (0, _slicedToArray2.default)(_ref, 3),
                  base = _ref2[0],
                  companyId = _ref2[1],
                  contactId = _ref2[2];

              return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(base, "/v1/companies/")).call(_context2, companyId, "/contacts/")).call(_context, contactId, "/user-preferences/time-and-expense-entry");
            }).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x5) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));
  return _getTimeAndExpenseEntry.apply(this, arguments);
}

function setTimeAndExpenseEntry(_x2, _x3) {
  return _setTimeAndExpenseEntry.apply(this, arguments);
}

function _setTimeAndExpenseEntry() {
  _setTimeAndExpenseEntry = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(options, body) {
    return _regenerator.default.wrap(function _callee6$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", _promise.default.all([(0, _environment.getRoute)('CoreServices'), options.companyId ? options.companyId : (0, _session.getCompanyId)(), options.contactId ? options.contactId : (0, _session.getContactId)()]).then(function (_ref5) {
              var _context6, _context7;

              var _ref6 = (0, _slicedToArray2.default)(_ref5, 3),
                  base = _ref6[0],
                  companyId = _ref6[1],
                  contactId = _ref6[2];

              return (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "".concat(base, "/v1/companies/")).call(_context7, companyId, "/contacts/")).call(_context6, contactId, "/user-preferences/time-and-expense-entry");
            }).then( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(url) {
                return _regenerator.default.wrap(function _callee4$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        return _context8.abrupt("return", fetch(url, {
                          method: 'PUT',
                          body: (0, _stringify.default)(body),
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x6) {
                return _ref7.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(response) {
                return _regenerator.default.wrap(function _callee5$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        return _context9.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x7) {
                return _ref8.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee6);
  }));
  return _setTimeAndExpenseEntry.apply(this, arguments);
}
